import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/inquiries", form);
      setSubmitted(true);
      toast.success("Thank you — we'll be in touch soon.");
    } catch (err) {
      toast.error("Could not submit. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="page-contact">
      <section className="border-b border-border bg-cream">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:px-12 lg:py-28">
          <div className="section-label">Get in touch</div>
          <h1 className="mt-4 font-serif text-5xl tracking-tight sm:text-6xl">Say hello.</h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-stone">
            Questions about an upcoming litter, the waitlist, or care? Drop us a note. We reply within 1–2 days.
          </p>
        </div>
      </section>

      <section className="mx-auto grid max-w-6xl gap-16 px-6 py-20 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5 space-y-8 text-sm">
          <div>
            <div className="section-label">Email</div>
            <div className="mt-2 font-serif text-2xl">hello@alabamalionsmanerabbitry.com</div>
          </div>
          <div>
            <div className="section-label">Phone</div>
            <div className="mt-2 font-serif text-2xl">(256) 555-0142</div>
          </div>
          <div>
            <div className="section-label">Location</div>
            <div className="mt-2 font-serif text-2xl">Northeast Alabama<br />By appointment only</div>
          </div>
        </div>
        <div className="lg:col-span-7">
          {submitted ? (
            <div className="border border-border bg-muted p-10 text-center" data-testid="contact-success">
              <div className="font-serif text-3xl text-terracotta">Thank you!</div>
              <p className="mt-3 text-stone">Your message has been received. We'll reach out within 1–2 days.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-5 border border-border bg-white p-8" data-testid="contact-form">
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-stone">Name</label>
                <input
                  required value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  data-testid="contact-input-name"
                  className="mt-2 w-full border border-border bg-cream px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta"
                />
              </div>
              <div className="grid gap-5 sm:grid-cols-2">
                <div>
                  <label className="text-xs uppercase tracking-[0.2em] text-stone">Email</label>
                  <input
                    required type="email" value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    data-testid="contact-input-email"
                    className="mt-2 w-full border border-border bg-cream px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta"
                  />
                </div>
                <div>
                  <label className="text-xs uppercase tracking-[0.2em] text-stone">Phone</label>
                  <input
                    value={form.phone}
                    onChange={(e) => setForm({ ...form, phone: e.target.value })}
                    data-testid="contact-input-phone"
                    className="mt-2 w-full border border-border bg-cream px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta"
                  />
                </div>
              </div>
              <div>
                <label className="text-xs uppercase tracking-[0.2em] text-stone">Message</label>
                <textarea
                  required rows={5} value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  data-testid="contact-input-message"
                  className="mt-2 w-full border border-border bg-cream px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-terracotta"
                />
              </div>
              <button
                disabled={busy}
                data-testid="contact-submit"
                className="rounded-full bg-terracotta px-8 py-3.5 text-sm text-white transition-transform hover:-translate-y-0.5 disabled:opacity-60"
              >
                {busy ? "Sending…" : "Send message"}
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}
